import React, { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { MUTATION_DELETE_SUSPICIOUS_NUMBERS } from "../../../constants/graphql/drop-off-graphql";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { getStatusWithSuspendedCheck } from "../../../utils/agent-helpers";
import {
  FETCH_AGENT_VERIFICATION_HISTORY,
  GET_AGENT_BY_ID,
} from "../../../constants/graphql/partner-agent-queries";
import {
  Textfield,
  Button as Button2,
  TableWithHeader,
  Textarea,
} from "../../../components/core";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";
import { GET_SUSPICIOUS_NUMBERS_BY_AGENT_ID } from "../../../constants/graphql/suspicious-numbers-per-agent-queries";
import { formatDateTime } from "../../../algorithms/date";
import SuspisciousNumbersPerAgent from "./modals/sus-numbers-dialog";
import NewDataTable from "../../../components/new-core/data-table";
import StatusHistoryModal from "../agent-profile/modals/status-history-modal";

export default function UnrecogTable({
  headers = [],
  items = [],
  dt,
  handleEdit = () => {},
}) {
  console.log({ items });
  const [isLoading, setLoading] = useState(false);
  const [editSupiciousNubmer, setEditNumber] = useState({
    visibility: false,
    newNumber: "",
    oldNumber: "",
  });
  const [errorDialog, seterrorDialog] = useState({
    visibility: false,
    title: "",
    content: "",
    forError: true,
  });
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );

  const [fetchAgentStatusHistory] = useLazyQuery(
    FETCH_AGENT_VERIFICATION_HISTORY,
    { fetchPolicy: "no-cache" },
  );

  const [getAgentById] = useLazyQuery(GET_AGENT_BY_ID);

  const [fetchSuspiciousNumbers] = useLazyQuery(
    GET_SUSPICIOUS_NUMBERS_BY_AGENT_ID,
  );

  const severityOptions = [
    { value: "0", name: "low" },
    { value: "1", name: "medium" },
    { value: "2", name: "high" },
  ];

  const severity = {
    0: "low",
    1: "medium",
    2: "high",
  };

  const getSeverity = (status) => {
    switch (status) {
      case "high":
        return "danger";
      case "low":
        return "info";
      case "medium":
        return "warning";
    }
  };

  const [editDialog, setEditDialog] = useState({
    visibility: false,
    title: "",
    content: "",
    forError: true,
  });

  const [agentHistory, setagentHistory] = useState({
    visibility: false,
    statusHistory: [],
  });
  console.log({ agentHistory });

  const [agentRelatedNum, setAgentRelatedNum] = useState({
    visibility: false,
    agentId: "",
    firstName: "",
    lastName: "",
    statusHistory: [],
    relatedNumbers: [],
  });

  const [clickedRow, setClickedRow] = useState({});

  const [deleteSuspicious] = useMutation(MUTATION_DELETE_SUSPICIOUS_NUMBERS);

  console.log({ clickedRow });
  const actionTemplate = (rowData, data) => {
    return (
      <div
        className={`flex flex-row gap-2 w-min  ${
          accessPermission.suspiciousCourierTagging === 1 ||
          accessPermission.suspiciousCourierTagging === "1"
            ? "hidden"
            : ""
        }`}
      >
        <Button
          size="small"
          icon="pi pi-pencil"
          className="flex items-center bg-yellow-500 text-white border-0 p-[1px] py-[10px]"
          onClick={() => {
            setLoading(true);
            setClickedRow({
              ...rowData,
              warning: rowData.recipientMobile.toString().split("|")[0],
              severity: rowData.recipientMobile.toString().split("|")[1],
            });
            setEditDialog((prevErrors) => ({
              ...prevErrors,
              visibility: true,
            }));
            setLoading(false);
          }}
          disabled={isLoading}
        />

        <Button
          size="small"
          icon="pi pi-trash"
          className="flex items-center bg-red-500 text-white border-0 p-[1px] py-[10px]"
          onClick={() => {
            setLoading(true);
            setClickedRow({ ...rowData });
            seterrorDialog((prevErrors) => ({
              ...prevErrors,
              visibility: true,
            }));
            setLoading(false);
          }}
          disabled={isLoading}
        />
      </div>
    );
  };

  const occurenceBodyTemplate = (rowData, data) => {
    const splitArray = rowData.recipientMobile.split("|");
    const length = splitArray.length;

    if (length === 2) {
      return splitArray[0];
    } else {
      return "";
    }
  };

  const agentMobileTemplate = (rowData, data) => {
    return rowData.agentMobile?.toString().substring(2);
  };

  const agentStatusTemplate = (rowData, data) => {
    // agentStatus is already resolved to a string ("Active", "Blocked", "Suspended", "Unknown")
    // by the parent index.js mapping, so use it directly
    const status = rowData.agentStatus;
    return (
      <div className="flex flex-row justify-between items-center">
        <Tag
          value={getStatusWithSuspendedCheck(
            rowData.agentStatus,
            rowData.agentStatusComment,
          )}
          className={`${
            rowData.agentStatus === 1 
              ? "bg-green-400" // Active
              : rowData.agentStatus === -1 &&
                  rowData.agentStatusComment
                    ?.toLowerCase()
                    .includes("suspended")
                ? "bg-orange-400" // Suspended
                : rowData.agentStatus === -1
                  ? "bg-red-400" // Blocked
                  : "bg-gray-400" // Unknown (0 or any other value)
          } text-secondary-purpleGray`}
        />
        <Button
          size="small"
          icon="pi pi-history"
          className="flex items-center bg-white text-black border-0 p-[1px] py-[5px]"
          onClick={() => {
            setLoading(true);

            // fetch the agent status history
            fetchAgentStatusHistory({
              variables: {
                partnerAgentId: rowData.partnerAgentId,
                agentStatus: true,
                verifiedStatus: false,
              },
            })
              .then((r) => {
                console.log({ HELLO: r });
                setagentHistory((prevErrors) => ({
                  ...prevErrors,
                  statusHistory: r.data.agentStatusHistory,
                  visibility: true,
                }));
              })
              .catch((e) => {})
              .finally(() => {
                setLoading(false);
              });
          }}
          disabled={isLoading}
        />
      </div>
    );
  };

  console.log({ items });
  const agentSuspiciousNumbersTemplate = (rowData, data) => {
    console.log({ rowData });
    return (
      <div className="flex flex-row justify-between">
        {rowData.relatedSuspiciousMobiles}
        <Button
          size="small"
          icon="pi pi-history"
          className="flex items-center bg-white text-black border-0 p-[1px] py-[5px]"
          onClick={() => {
            setLoading(true);
            setAgentRelatedNum((prevErrors) => ({
              ...prevErrors,
              relatedNumbers: [],
            }));
            // setAgentRelatedNum((prevErrors) => ({
            //   ...prevErrors,
            //   visibility: true,
            // }));
            getAgentById({
              variables: {
                agentId: parseInt(rowData.partnerAgentId),
              },
            })
              .then((data) => {
                console.log({ data });

                const responseData = data.data.getAgentById[0];

                console.log({ responseData });
                if (responseData) {
                  setAgentRelatedNum({
                    ...agentRelatedNum,
                    visibility: true,
                    agentId: responseData.partnerAgentId,
                    relatedNumbers: responseData.suspiciousMobiles,
                    firstName: responseData.firstName,
                    lastName: responseData.lastName,
                    comments: responseData.comments,
                    agentStatusComments: responseData.agentStatusComments,
                  });
                }
              })
              .catch((error) => {})
              .finally(() => {
                setLoading(false);
              });

            // fetchSuspiciousNumbers({
            //   variables: {
            //     partnerAgentId: rowData.partnerAgentId,
            //     agentStatus: true,
            //   },
            // })
            //   .then((r) => {
            //     console.log({ DATA: r });

            //     setAgentRelatedNum((prevErrors) => ({
            //       ...prevErrors,
            //       relatedNumbers: r.data.suspiciousNumbersPerAgent,
            //     }));
            //   })
            //   .catch((e) => {})
            //   .finally(() => {
            //     setLoading(false);
            //   });
          }}
          disabled={isLoading}
        />
      </div>
    );
  };

  console.log({ agentRelatedNum });
  const severityBodyTemplate = (rowData, data) => {
    // const splitArray = rowData.recipientMobile.split("|");
    const length = parseInt(rowData.severity);

    // if (length === 2) {
    return (
      <Tag value={severity[length]} severity={getSeverity(severity[length])} />
    );
    // } else {
    // 	return "";
    // }
  };

  const mobileNumberBodyTemplate = (rowData, data) => {
    return "";
  };

  const renderColumn = (data) => {
    const baseColumn = (
      <Column
        field={data.header_key}
        sortable
        className={`max-w-[200px] break-words`}
        header={data.header_name}
        headerStyle={{ backgroundColor: "#FECD08" }}
      />
    );

    switch (data.header_key) {
      case "blank":
        return (
          <Column
            field={data.header_key}
            header={data.header_name}
            style={{ display: "none" }}
          />
        );

      case "agentName":
        return data.tag === "1" ? (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            bodyClassName="font-bold cursor-pointer"
          />
        ) : data.tag === "2" ? (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            body={mobileNumberBodyTemplate}
            headerStyle={{ backgroundColor: "#FECD08" }}
          />
        ) : (
          baseColumn
        );
      case "agentMobile":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            body={agentMobileTemplate}
          />
        );
      case "agentStatus":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            body={agentStatusTemplate}
          />
        );
      case "relatedSuspiciousMobiles":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            body={agentSuspiciousNumbersTemplate}
          />
        );
      case "recipientMobile":
        return baseColumn;
      case "severity":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            body={severityBodyTemplate}
          />
        );
      case "totalOffenses":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            headerStyle={{ backgroundColor: "#FECD08" }}
            body={occurenceBodyTemplate}
          />
        );
      case "updatedAt":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            body={formatDate00}
            headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
          />
        );
      case "signupDate":
        return (
          <Column
            field={data.header_key}
            sortable
            header={data.header_name}
            body={formatDate00}
            headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
          />
        );
      case "action":
        return (
          <Column
            field={data.header_key}
            header={data.header_name}
            body={actionTemplate}
            headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
          />
        );
      default:
        return baseColumn;
    }
  };

  return (
    <>
      <DataTable
        value={items}
        paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
        currentPageReportTemplate="Rows per page"
        paginator
        paginatorRight
        rowsPerPageOptions={[10, 20, 50]}
        rows={10}
        sortMode="multiple"
        className="border border-black"
        removableSort
        exportFilename="Suspicious Courier Tagging"
        showGridlines
        tableStyle={{
          minWidth: "50rem",
          borderWidth: 2,
          borderColor: "#E6E6E6",
        }}
        emptyMessage={<div></div>}
        ref={dt}
        cellSelection={true}
        onCellClick={(e) => {
          if (e.field === "agentName") {
            window.open(
              `/operator/admin/agents/agentProfile/${e.rowData.partnerAgentId}`,
              "_blank",
            );
          }
        }}
      >
        {headers.map((data, key) => renderColumn(data))}
      </DataTable>
      <Dialog
        visible={errorDialog.visibility}
        headerClassName="p-1 m-0"
        className="w-[350px]"
        onHide={() => {
          seterrorDialog((prevErrors) => ({
            ...prevErrors,
            visibility: false,
          }));
        }}
      >
        <div className="flex flex-col justify-center items-center">
          <img
            alt="cancel-icon"
            className="h-[90px] mr-2"
            src={
              errorDialog.forError
                ? "https://files.axshare.com/gsc/WVWZ57/33/6d/24/336d246d351f4c1fa96b79e22e01b267/images/define_doors/u29.png?pageId=a40ab7eb-ce47-459a-9061-03fbe05c510f"
                : "https://files.axshare.com/gsc/WVWZ57/33/6d/24/336d246d351f4c1fa96b79e22e01b267/images/support_station_profile/u124.png?pageId=64ebdf4b-41c7-47aa-9541-58d77247c3a1"
            }
          />
          <p className="font-bold text-[16px] mb-[10px]">
            Remove Suspicious Courier?
          </p>
          <p className="text-[14px] mb-[10px]">
            Are you sure you want to delete the entry? This action cannot be
            undone.
          </p>
          <div className="flex flex-row justify-center items-center">
            <Button
              size="small"
              className="flex items-center gap-2 bg-primary-primaryYellow text-black border-0 w-full justify-center mt-[10px] mr-[10px] px-[10px] py-1 font-bold"
              onClick={() => {
                seterrorDialog((prevErrors) => ({
                  ...prevErrors,
                  visibility: false,
                }));
              }}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              size="small"
              className="flex items-center gap-2 bg-red-500 text-black border-0 w-full justify-center mt-[10px]  px-[10px] py-1 font-bold text-white"
              onClick={() => {
                deleteSuspicious({
                  variables: {
                    partnerAgentSuspiciousId:
                      clickedRow.partnerAgentSuspiciousId,
                  },
                }).then((r) => {
                  seterrorDialog((prevErrors) => ({
                    ...prevErrors,
                    visibility: false,
                  }));
                  window.location.reload();
                });
              }}
              disabled={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={editDialog.visibility}
        closeOnEscape={false}
        onHide={() =>
          setEditDialog((prevErrors) => ({ ...prevErrors, visibility: false }))
        }
        headerClassName="p-1 m-0"
        className="w-[550px]"
      >
        <div className="flex flex-col justify-center items-start">
          <p className="font-bold text-[16px] mb-[20px] w-full text-center">
            Edit Suspicious Courier
          </p>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Agent ID:</p>
            <InputText
              type="text"
              readOnly
              value={clickedRow.partnerAgentId}
              onChange={(e) => {
                setClickedRow((prev) => ({
                  ...prev,
                  partnerAgentId: e.target.value,
                }));
              }}
              maxLength={10}
              placeholder={`Enter Agent Id`}
              className="appearance-none  col-span-4"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2"># of Offenses:</p>
            <InputText
              type="int"
              keyfilter={"int"}
              value={clickedRow.warning}
              onChange={(e) => {
                setClickedRow((prev) => ({
                  ...prev,
                  warning: e.target.value,
                }));
              }}
              maxLength={3}
              placeholder={`1`}
              className="appearance-none col-span-4"
              pt={{
                root: {
                  className: "border border-gray-200 p-1 h-10 rounded-md",
                },
              }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Severity:</p>
            <Dropdown
              value={`${clickedRow.severity}`}
              onChange={(e) => {
                setClickedRow((prev) => ({
                  ...prev,
                  severity: e.value,
                }));
              }}
              options={severityOptions}
              optionLabel="name"
              // width={"300px"}
              placeholder="Choose severity"
              className="col-span-4 border h-10  items-center"
              style={{ borderColor: "#e2e8f0" }}
            />
          </div>

          <div className="grid grid-cols-6 gap-1 items-center w-full mb-2">
            <p className="text-[14px] col-span-2">Remarks:</p>
            <Textarea
              type="text"
              value={clickedRow.reason}
              onChange={(e) => {
                setClickedRow((prev) => ({
                  ...prev,
                  reason: e.target.value,
                }));
              }}
              maxLength={1000}
              placeholder={`Enter Reason`}
              classNameParent={" grid col-span-4"}
              className="appearance-none "
            />
          </div>
          <div className="flex flex-row gap-2 mt-[20px] justify-center w-full">
            {/* <div className="flex flex-row items-center w-full"> */}
            <Button2
              value={"Cancel"}
              onClick={(event) => {
                setEditDialog((prevErrors) => ({
                  ...prevErrors,
                  visibility: false,
                }));
              }}
              className={"w-40 h-8 mx-5 my-1 bg-secondary-buttonGray"}
            />
            <Button2
              value={"EDIT"}
              onClick={(event) => {
                handleEdit({
                  id: clickedRow.partnerAgentSuspiciousId,
                  partnerAgentId: clickedRow.partnerAgentId,
                  recipientMobile:
                    clickedRow.warning + "|" + clickedRow.severity,
                  reason: clickedRow.reason,
                });
                setEditDialog((prevErrors) => ({
                  ...prevErrors,
                  visibility: false,
                }));
              }}
              className={"w-40 h-8 mx-5 my-1 bg-primary-primaryYellow"}
            />
          </div>
        </div>
      </Dialog>

      <StatusHistoryModal
        statusHistory={agentHistory.statusHistory}
        isOpen={agentHistory.visibility}
        onClose={() => {
          setagentHistory((prevErrors) => ({
            ...prevErrors,
            statusHistory: [],
          }));
          setagentHistory((prevErrors) => ({
            ...prevErrors,
            visibility: false,
          }));
        }}
      />

      <SuspisciousNumbersPerAgent
        open={agentRelatedNum.visibility}
        onHide={() => {
          setAgentRelatedNum((prevErrors) => ({
            ...prevErrors,
            relatedNumbers: [],
          }));
          setAgentRelatedNum((prevErrors) => ({
            ...prevErrors,
            visibility: false,
          }));
        }}
        suspiciousData={agentRelatedNum}
        accessPermission={accessPermission}
        setLoading={setLoading}
        isLoading={isLoading}
      />
    </>
  );
}

const formatDate00 = (e) => {
  if (e.updatedAt == null) {
    return "";
  }
  const date = new Date(e.updatedAt?.toString().split("T")[0]);
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  console.log({ date, options });
  return `${date?.toLocaleDateString(undefined, options)}`;
};
